'use client';

import { useEffect } from 'react';
import './globals.css';

/**
 * Last-resort boundary that replaces the root layout when it itself throws.
 * It must render its own <html>/<body>; styling relies on the CSS variables
 * from globals.css so it stays on brand in light and dark modes.
 */
const GlobalError = ({ error, reset }: { error: Error & { digest?: string }; reset: () => void }) => {
  useEffect(() => {
    console.error('[global-error]', error);
  }, [error]);

  return (
    <html lang='pt-BR'>
      <body
        style={{
          margin: 0,
          backgroundColor: 'hsl(var(--background))',
          color: 'hsl(var(--foreground))',
          fontFamily: 'var(--font-sans), Manrope, ui-sans-serif, system-ui, -apple-system, sans-serif',
        }}
      >
        <div
          style={{
            minHeight: '100vh',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '2rem',
          }}
        >
          <div style={{ textAlign: 'center', maxWidth: 460 }}>
            <p
              style={{
                margin: 0,
                color: 'hsl(var(--primary))',
                letterSpacing: '0.2em',
                fontWeight: 700,
                textTransform: 'uppercase',
                fontSize: '0.8rem',
              }}
            >
              Erro inesperado
            </p>
            <h1 style={{ fontSize: '2.2rem', lineHeight: 1.15, margin: '0.8rem 0' }}>
              Não foi possível carregar a página
            </h1>
            <p style={{ color: 'hsl(var(--muted-foreground))', margin: '0 0 1.6rem' }}>
              Ocorreu uma falha inesperada. Tente novamente; se o problema persistir, volte mais tarde.
            </p>
            <button
              onClick={reset}
              style={{
                border: 'none',
                cursor: 'pointer',
                borderRadius: 999,
                padding: '0.7rem 1.6rem',
                fontWeight: 700,
                backgroundColor: 'hsl(var(--primary))',
                color: 'hsl(var(--primary-foreground))',
              }}
            >
              Tentar novamente
            </button>
          </div>
        </div>
      </body>
    </html>
  );
};

export default GlobalError;
